import { createSelectBlockMiddleware } from 'components/MCTextEditor/shared/middleware/selectBlock'
import { SliceType } from 'components/MCTextEditor/slice/types'

export const selectVariable = createSelectBlockMiddleware(SliceType.VARIABLE)
